import { ComponentFactoryResolver, ComponentRef, OnDestroy, Self } from '@angular/core';
import { Directive, OnInit, ViewContainerRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ControlErrorComponent } from '@app/shared/components/control-error/control-error.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[formControl], [formControlName]',
    standalone: true
})
export class FormControlErrorDirective implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject();
  private errorRef: ComponentRef<ControlErrorComponent> = null;

  constructor(
    @Self() private control: NgControl,
    private vcr: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {
  }

  ngOnInit(): void {
    this.control.statusChanges.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(() => {

      const userInputtedAndInvalid = this.control.status === 'INVALID' && this.control.dirty;
      if (userInputtedAndInvalid) {
        if (!this.errorRef) {
          const factory = this.componentFactoryResolver.resolveComponentFactory(ControlErrorComponent);
          this.errorRef = this.vcr.createComponent(factory);
        }

        this.errorRef.instance.errors = this.control.errors;

      } else if (this.errorRef) {
        this.errorRef.destroy();
        this.errorRef = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }
}
